import { render, staticRenderFns } from "./ChatIA.vue?vue&type=template&id=5849406c&scoped=true"
import script from "./ChatIA.vue?vue&type=script&lang=js"
export * from "./ChatIA.vue?vue&type=script&lang=js"
import style0 from "./ChatIA.vue?vue&type=style&index=0&id=5849406c&prod&scoped=true&lang=css"
import style1 from "./ChatIA.vue?vue&type=style&index=1&id=5849406c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5849406c",
  null
  
)

export default component.exports